import React from 'react';

import './logo.styl';

import { appLocaleType } from 'app/pages/app/app.types';

const propTypes = {
  locale: appLocaleType.isRequired,
};

const defaultProps = {
  //
};

const Logo = ({ locale }) => <div className="logo">{locale === 'en' && 'RAWG'}</div>;

Logo.propTypes = propTypes;
Logo.defaultProps = defaultProps;

export default Logo;
